<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`${modal}${prefix}`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="800"
  >
       <p-button class="w-100 btn-sm mb-2 " type="info" @click.native.prevent="accept"
          >Применить</p-button
        >

         <p-button
          class="btn-sm w-100 mb-4"
          type="warning"
          round
          @click.native.prevent="closeModal"
          >Отмена</p-button
        >

    <card v-if="model">

     
      <list
        :columns="model.columns"
        :modalCreate="model.modalCreate"
        :removeLink="model.removeLink"
        :cardLink="model.cardLink"
        :isUpdate="model.isUpdate"
        :params="params"
        :isAdd="model.isAdd"
        :itemLink="model.itemLink"
        :setLink="model.setLink"
        :fields="model.fields"
        :searchDisable="model.searchDisable"
        v-model="val"
        :simple="simple"
      />
  
      
    </card>

       <p-button class="w-100 btn-sm mb-2 " type="info" @click.native.prevent="accept"
          >Применить</p-button
        >

         <p-button
          class="btn-sm w-100 mb-4"
          type="warning"
          round
          @click.native.prevent="closeModal"
          >Отмена</p-button
        >
  </modal>
</template>
<script>
import List from "../List";

export default {
  name: "ListItem",
  data() {
    return {
      val: [],
    };
  },
  props: {
    modal: {
      default: function () {
        return "";
      },
    },
    params: {
      default: function(){
        return {};
      },
    },
    prefix: {
      default: function () {
        return "";
      },
    },
    simple: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.$store.state.modals[this.modal];
      },
    },
  },
  created() {
    this.val = this.value;
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  components: {
    List,
  },
  methods: {
    modalClose() {},
    modalOpen() {},
    closeModal() {
      this.$modal.hide(`${this.modal}${this.prefix}`);
    },
    accept() {
      if (this.val) {
        this.$modal.hide(`${this.modal}${this.prefix}`);
        this.$emit("input", this.val);
        //denis_test
        this.val = [];
      }
    },
  },
};
</script>

